__turbopack_context__.v({
  "icon": "label-module__8T09ca__icon",
  "label": "label-module__8T09ca__label",
  "optionnal": "label-module__8T09ca__optionnal",
  "smallLabel": "label-module__8T09ca__smallLabel",
});
